module.exports = __webpack_public_path__ + "img/out-of-stock.cf919c90.png";